import { Injectable } from '@angular/core';
import { AuthenticationService } from './authentication.service';
import { User, DepartmentRole } from '../models/user.model';

@Injectable({
  providedIn: 'root'
})
export class PermissionService {
  constructor(private authService: AuthenticationService) {}

  /**
   * Check if user has specific permission in any of their departments
   * @param permission The permission to check
   * @param module The module/category of the permission
   * @returns boolean
   */
  hasPermission(permission: string, module: string): boolean {
    console.log("hasPermission >>>>>");
    console.log("permission >>>>>",permission);
    console.log("module >>>>>",module);

    const currentUser:any = this.authService.currentUserValue;
    if (!currentUser) return false;
    if (currentUser.role == 'admin') return true;
    return this.checkPermissionInRoles(currentUser.assignedDepartmentRole, permission, module);
  }

  /**
   * Check if user has all of the specified permissions
   * @param permissions Array of permissions to check
   * @param module The module/category of the permissions
   * @returns boolean
   */
  hasAllPermissions(permissions: string[], module: string): boolean {
    return permissions.every(permission => this.hasPermission(permission, module));
  }

  /**
   * Check if user has any of the specified permissions
   * @param permissions Array of permissions to check
   * @param module The module/category of the permissions
   * @returns boolean
   */
  hasAnyPermission(permissions: string[], module: string): boolean {
    return permissions.some(permission => this.hasPermission(permission, module));
  }

  /**
   * Check if user has permission in specific department
   * @param permission The permission to check
   * @param module The module/category of the permission
   * @param department The department name to check
   * @returns boolean
   */
  hasPermissionInDepartment(permission: string, module: string, department: string): boolean {
    const currentUser:any = this.authService.currentUserValue;
    // console.log(currentUser);
    if (!currentUser) return false; 
    if (currentUser.role == 'admin') return true;


    const departmentRole = currentUser.assignedDepartmentRole.find(
      role => role.department == department
    );

    return departmentRole ? this.checkPermissionInRole(departmentRole, permission, module) : false;
  }

  /**
   * Get all departments where user has specific permission
   * @param permission The permission to check
   * @param module The module/category of the permission
   * @returns Array of department names
   */
  getDepartmentsWithPermission(permission: string, module: string): string[] {
    const currentUser:any = this.authService.currentUserValue;
    if (!currentUser) return [];

    return currentUser.assignedDepartmentRole
      .filter(role => this.checkPermissionInRole(role, permission, module))
      .map(role => role.department);
  }

  private checkPermissionInRoles(roles: DepartmentRole[], permission: string, module: string): boolean {
    return roles.some((role:any) => this.checkPermissionInRole(role, permission, module));
  }

  private checkPermissionInRole(role: DepartmentRole, permission: string, module: string): boolean {
    let havePermission = role.permissions[module]?.includes(permission) || false;
    return havePermission;
  }
}
